export interface OmsServiceErrorOptions {
  /** The `meta` property can and should contain any extra data provided by the server, but it should at minimum include the properties named here. */
  meta: {
    __typename: string;
    errorCode: string;
  };
}

/**
 * OmsServiceError classifies errors from the OMS Service.
 * @see: https://github.com/leaflink/oms-service
 */
export class OmsServiceError extends Error {
  public isOmsServiceError: boolean;
  public meta: OmsServiceErrorOptions['meta'];

  constructor(message: string, { meta }: OmsServiceErrorOptions) {
    super(message);

    this.name = 'OmsServiceError';
    this.isOmsServiceError = true;
    this.meta = meta;
  }
}
